<template>
  <div class="subscriber-language-graph d-flex flex-column">
    <h5 class="subscriber-language-graph--title">{{title}}</h5>
    <div class="subscriber-language-graph--body">
      <div id="subscriberLanguageGraph"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ApexCharts from 'apexcharts';
import { mapGetters } from 'vuex';

export default {
  name: "SubscriberLanguageGraph",
  props: {
    graphData: {
      type: Object,
      required: true,
    },
    dialects: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
      options: {
        series: [],
        chart: {
          width: "100%",
          height: "400px",
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
            donut: {
              labels: {
                show: true,
                width: 300,
                color: "white",
              },
              size: "50%",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: [],
        stroke: {
          width: 1,
        },
        legend: {
          enabled: false,
          markers: {
            radius: 0,
          },
          fontSize: "14px",
          width: 140,
        },
        responsive: [
          {
            breakpoint: 1600,
            options: {
              legend: {
                width: undefined,
                height: 60,
                position: "bottom",
              }
            }
          }
        ]
      },
    };
  },
  computed: {
    ...mapGetters("user", ["isDarkMode"]),
    title() {
      if (this.graphData.total) {
        const formattedTotal = `${this.graphData.total}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `Subscriber Language (${formattedTotal})`;
      }
      return "Subscriber Language";
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.chart = new ApexCharts(
        document.querySelector("#subscriberLanguageGraph"),
        { ...this.options },
      );
      this.chart.render();
    },
    updateChart(graphData) {
      const { data } = graphData;
      if (data && data.length > 0) {
        const series = [...data.map(item => item.count)];
        const options = {
          ...this.options,
          series,
          labels: data.map(item => {
            const { lang } = item;
            const language = this.dialects.find(item => item.code === lang);
            if (language && language.label) {
              return language.label;
            }
            return lang;
          })
        };
        if (this.isDarkMode) {
          options['theme'] = { mode: 'dark' };
        }
        setTimeout(() => {
          this.chart.updateSeries(series);
          this.chart.updateOptions(options);
        }, 100);
      }
    }
  },
  watch: {
    graphData: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal || {}) !== JSON.stringify(oldVal || {})) {
          this.updateChart(newVal);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style lang="scss">
.subscriber-language-graph {
  width: 100%;
  gap: 0.5rem;
  &--title {
    margin: 0;
    height: 20px;
    line-height: 20px;
  }
}
</style>
